import type { FC, ReactNode } from 'react'

import { Plus } from 'lucide-react'
import SectionHeading from '@/components/landing/section-heading'
import { invitation } from '@/constants/invitation'

const FaqSection: FC = (): ReactNode => {
    return (
        <section id='faq' aria-labelledby='faq-titre' className='py-24 sm:py-32'>
            <div className='mx-auto grid max-w-6xl gap-12 px-5 sm:px-8 lg:grid-cols-[0.8fr_1.2fr] lg:gap-16'>
                <div className='lg:sticky lg:top-28 lg:self-start'>
                    <SectionHeading
                        id='faq-titre'
                        eyebrow="Questions fréquentes"
                        title="Une petite question ?"
                        description={
                            <>
                                Vous trouverez sûrement la réponse ici. Sinon, glissez-la dans le{' '}
                                <a
                                    href='/#rsvp'
                                    className='rounded-sm font-semibold text-foreground underline decoration-primary/40 underline-offset-4 outline-none hover:decoration-primary focus-visible:ring-[3px] focus-visible:ring-ring/40'
                                >
                                    formulaire de réponse
                                </a>
                                , je vous réponds vite.
                            </>
                        }
                    />
                </div>

                <div className='space-y-3'>
                    {invitation.faq.map((item, index) => (
                        <details
                            key={item.question}
                            open={index === 0}
                            className='group rounded-2xl bg-card shadow-sm ring-1 ring-foreground/5 transition-shadow open:shadow-md'
                        >
                            <summary className='flex cursor-pointer list-none items-center justify-between gap-4 rounded-2xl px-6 py-5 text-left text-lg font-semibold outline-none focus-visible:ring-[3px] focus-visible:ring-ring/40 [&::-webkit-details-marker]:hidden'>
                                {item.question}

                                <span className='grid size-8 shrink-0 place-items-center rounded-full bg-muted transition-all duration-300 group-open:rotate-45 group-open:bg-primary group-open:text-primary-foreground motion-reduce:transition-none'>
                                    <Plus className='size-4' aria-hidden='true' />
                                </span>
                            </summary>

                            <p className='px-6 pb-6 leading-relaxed text-muted-foreground text-pretty'>
                                {item.answer}
                            </p>
                        </details>
                    ))}
                </div>
            </div>
        </section>
    )
}

export default FaqSection
